import React from "react";
import style from "./About.module.css";

const About = () => {
  return (
    <div>
      <h3 style={{ textAlign: "center", padding: "300px" }}>
        DEVELOPER ZIHAD IS WORKING
      </h3>
    </div>
  );
};

export default About;

